// extracted by mini-css-extract-plugin
export var dateLabel = "_40-0";
export var dateLabelError = "_40-1";
export var fullWidth = "_40-2";
export var smaller = "_40-3";